export default function ScrollToTopSvg() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.6665 14.1663L9.99984 10.833L13.3332 14.1663" stroke="currentColor" strokeWidth="1.25"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.6665 9.16634L9.99984 5.83301L13.3332 9.16634" stroke="currentColor" strokeWidth="1.25"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
